export default {
  BLACK: 'black',
  WHITE: 'white',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  LINK: 'Link',
  BUTTON: 'Button'
}
